import React from "react";
import {
  TableBody as Body,
  TableRow as Row,
  TableCell as Cell,
} from "semantic-ui-react";

const TableBody = (props) => {
  return (
    <Body>
      {props.body.map((row, index) => (
        <Row key={index}>
          {row.map((cell) => (
            <Cell>{cell}</Cell>
          ))}
        </Row>
      ))}
    </Body>
  );
};

export default TableBody;
